import { render } from "./EnHelpIcon.vue?vue&type=template&id=36fd9735"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/EnHelpIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36fd9735"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36fd9735', __exports__)) {
    api.reload('36fd9735', __exports__)
  }
  
  module.hot.accept("./EnHelpIcon.vue?vue&type=template&id=36fd9735", () => {
    api.rerender('36fd9735', render)
  })

}


export default __exports__